import { useQueryClient } from "@tanstack/react-query";

import { api } from "@/lib/api";
import { useToast } from "@/components/toast";

// Save / unsave a profile and refresh every list that shows the heart.
export function useSaveToggle() {
  const qc = useQueryClient();
  const toast = useToast();
  return async (id, saved) => {
    try {
      await api(`/saved/${id}`, { method: saved ? "DELETE" : "POST" });
      toast(saved ? "Removed from saved" : "Saved to your list", "success");
      ["matches", "daily", "saved", "member", "dashboard"].forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
    } catch (e) {
      toast(e.message, "error");
    }
  };
}

export const SAFETY_KEYS = ["matches", "daily", "requests", "connections", "saved", "member", "unread", "dashboard", "blocks"];
